import { render, staticRenderFns } from "./OCrossTable.vue?vue&type=template&id=e7b1e114&scoped=true"
import script from "./OCrossTable.vue?vue&type=script&lang=js"
export * from "./OCrossTable.vue?vue&type=script&lang=js"
import style0 from "./OCrossTable.vue?vue&type=style&index=0&id=e7b1e114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b1e114",
  null
  
)

export default component.exports